// @flow
import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {connect} from 'react-redux';
import {getImageUrl} from '../../utils/image_provider';
import logo from '../../assets/img/qempo-tiendas-logo.png';

import type {ResellerInformation} from '../../entities';
import type {RootState} from '../../modules';

export default connect(
  (state: RootState) => ({
    resellerInformation: state.ui.resellerInformation,
    isFetchingResellerInformation: state.ui.isFetchingResellerInformation,
  }),
  null
)(VendorLogo);

type Props = {
  resellerInformation: ResellerInformation,
  isFetchingResellerInformation: boolean,
};

const useStyles = makeStyles(theme => ({
  logo: {
    height: 48,
    width: 'auto',
  },
}));

function VendorLogo(props: Props) {
  const {resellerInformation, isFetchingResellerInformation} = props;

  const classes = useStyles();

  if (isFetchingResellerInformation) return null;
  return (
    <img
      src={
        resellerInformation && resellerInformation.logoId
          ? getImageUrl(resellerInformation.logoId)
          : logo
      }
      alt="qempo"
      className={classes.logo}
    />
  );
}

VendorLogo.propTypes = {
  resellerInformation: PropTypes.object,
  isFetchingResellerInformation: PropTypes.bool,
};
